import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import { Box } from "@mui/material";
import type { ReactNode } from "react";
import type { VerificationStatus } from "Components/Users/UserDetailPageContent/Components/UserReadOnlyDetail/verificationStatusUtils";

const statusIcons = {
  verified: <CheckOutlinedIcon color="success" fontSize="small" />,
  pending: <WarningAmberOutlinedIcon color="warning" fontSize="small" />,
  "not-verified": <ClearOutlinedIcon color="error" fontSize="small" />,
} as const;

type Props = {
  label: ReactNode;
  status: VerificationStatus;
};

export const VerificationValue = ({ label, status }: Props) => (
  <Box display="inline-flex" alignItems="center" gap={0.5}>
    {statusIcons[status]}
    {label}
  </Box>
);
